module.exports = __webpack_public_path__ + "img/api-step-1@2x.975751ad.png";